import { useMutation, useQueryClient } from '@tanstack/react-query'
import type {
  DeleteOverrideRulesByFilterRequestDto,
  DeleteOverrideRulesByFilterResponseDto,
} from '../../../api/dto/plan-benefit-override-rules.dto'
import { deleteOverrideRulesByFilter } from '../../../api/plan-benefit-override-rules-api'
import { OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanBenefitOverride/hooks/useGetOverrideRules'

export function useDeleteOverrideRulesByFilter() {
  const queryClient = useQueryClient()

  return useMutation<
    DeleteOverrideRulesByFilterResponseDto,
    unknown,
    DeleteOverrideRulesByFilterRequestDto
  >({
    mutationFn: (params) => deleteOverrideRulesByFilter(params),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [OVERRIDE_RULES_QUERY_KEY] })
    },
  })
}
